var padding = {
  paddingNormal: 10,
  paddingCompact: 5
};
export default padding;